import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API_BASE } from '../../lib/config';

const API = `${API_BASE}`;

const JobQRPage = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [tokenInfo, setTokenInfo] = useState(null);

  const fetchToken = async () => {
    try {
      setLoading(true);
      setError('');
      const token = localStorage.getItem('token');
      const resp = await fetch(`${API}/employer/jobs/${jobId}/qr-token`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (!resp.ok) throw new Error(`failed: ${resp.status}`);
      const data = await resp.json();
      setTokenInfo(data);
    } catch (e) {
      console.error(e);
      setError('トークン取得に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (jobId) fetchToken();
    // eslint-disable-next-line
  }, [jobId]);

  const handleCopy = async () => {
    try {
      if (!tokenInfo?.token) return;
      await navigator.clipboard.writeText(tokenInfo.token);
      alert('QRトークンをコピーしました');
    } catch (_) {
      alert('コピーに失敗しました');
    }
  };

  const qrPayload = tokenInfo?.token ? `${tokenInfo.job_id}|${tokenInfo.token}` : '';
  const qrImageUrl = qrPayload
    ? `https://api.qrserver.com/v1/create-qr-code/?size=240x240&data=${encodeURIComponent(qrPayload)}`
    : '';

  return (
    <div className="max-w-md mx-auto p-4">
      <div className="flex items-center mb-4">
        <button onClick={() => navigate(-1)} className="text-gray-600 hover:text-gray-900 mr-3">戻る</button>
        <h1 className="text-xl font-bold">当日QRコード</h1>
      </div>

      {loading && (
        <div className="p-4 bg-white rounded shadow">読み込み中...</div>
      )}

      {error && (
        <div className="p-4 bg-red-50 text-red-700 rounded shadow mb-4">{error}</div>
      )}

      {!loading && !error && tokenInfo && (
        <div className="bg-white rounded-xl p-6 shadow">
          <div className="text-sm text-gray-600 mb-2">求人ID: {tokenInfo.job_id}</div>
          <div className="text-sm text-gray-600 mb-4">有効期限: {tokenInfo.expires_at}</div>

          {qrImageUrl && (
            <div className="flex justify-center mb-4">
              <img src={qrImageUrl} alt="QR Code" className="w-60 h-60 border rounded" />
            </div>
          )}

          <div className="mb-2">
            <div className="text-xs text-gray-500 mb-1">QRトークン</div>
            <div className="font-mono text-sm break-all p-2 bg-gray-50 rounded border">
              {tokenInfo.token}
            </div>
          </div>

          <div className="mb-2">
            <div className="text-xs text-gray-500 mb-1">QRペイロード（job_id|token）</div>
            <div className="font-mono text-sm break-all p-2 bg-gray-50 rounded border">
              {qrPayload}
            </div>
          </div>

          <div className="flex gap-2 mt-4">
            <button onClick={handleCopy} className="px-3 py-2 bg-blue-600 text-white rounded">コピー</button>
            <button onClick={fetchToken} className="px-3 py-2 bg-gray-100 rounded border">再発行</button>
          </div>
        </div>
      )}

      <div className="mt-6 text-sm text-gray-600">
        <ul className="list-disc pl-5 space-y-1">
          <li>QRは当日限り有効です（23:59:59まで）。</li>
          <li>現地でワーカーに読み取ってもらい、チェックイン時に自動照合されます。</li>
        </ul>
      </div>
    </div>
  );
};

export default JobQRPage;
